// Phase 49r.2: Reusable empty state for the 5+ pages that need it.
// Replaces inline "mailbox emoji + center text + CTA" blocks scattered
// across Transactions / Budgets / Add / CardDetail / NotFound.
// Each page passes its own title + hint + optional CTA. Default icon
// is 💼 (wallet) — reinforces personal-finance identity better than
// the generic mailbox 📭.
import React from 'react';

export default function EmptyState({
  icon = '💼',
  title,
  hint,
  actionLabel,
  onAction,
  size = 'md',
  testid = 'empty-state',
}) {
  const sizes = {
    sm: { wrap: 'py-6', iconText: 'text-3xl', titleText: 'text-sm', hintText: 'text-xs' },
    md: { wrap: 'py-12', iconText: 'text-5xl', titleText: 'text-base font-medium', hintText: 'text-sm' },
    lg: { wrap: 'py-16', iconText: 'text-6xl', titleText: 'text-lg font-semibold', hintText: 'text-base' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div
      data-testid={testid}
      className={[
        'text-center flex flex-col items-center gap-3',
        'text-slate-500 dark:text-slate-400',
        s.wrap,
      ].join(' ')}
    >
      <div
        className={[
          s.iconText,
          'rounded-full w-16 h-16 flex items-center justify-center',
          'bg-brand-50 dark:bg-brand-900/20',
          'border border-brand-100 dark:border-brand-900/40',
        ].join(' ')}
        aria-hidden="true"
      >
        {icon}
      </div>
      {title && (
        <p className={['text-slate-700 dark:text-slate-200', s.titleText].join(' ')}>{title}</p>
      )}
      {hint && (
        <p className={s.hintText}>{hint}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 inline-flex items-center gap-1.5 bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium px-4 py-2.5 rounded-lg min-h-[44px] shadow-sm"
        >
          <span aria-hidden="true">＋</span>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
